import { memo, useCallback } from "react";
import { SecurityCode } from "@mercadopago/sdk-react";
import styles from "../MpCardSecureFields/MpCardSecureFields.module.css";

const MP_FIELD_STYLE = {
  width: "100%",
  height: "40px",
} as const;

type Props = {
  onValidityChange: (isValid: boolean) => void;
};

const MpSavedCardSecurityCode = memo(function MpSavedCardSecurityCode({
  onValidityChange,
}: Props) {
  const handleValidityChange = useCallback(
    (e: { errorMessages: Array<{ message: string }> }) => {
      onValidityChange(e.errorMessages.length === 0);
    },
    [onValidityChange]
  );

  return (
    <div className={styles.col}>
      <label className={styles.fieldLabel} htmlFor="mp-saved-card-cvv">
        Confirme o CVV
      </label>
      <div id="mp-saved-card-cvv" className={styles.fieldBox}>
        <SecurityCode
          placeholder="123"
          style={MP_FIELD_STYLE}
          onValidityChange={handleValidityChange}
        />
      </div>
    </div>
  );
});

export default MpSavedCardSecurityCode;
